import React from 'react'
// import {BsLinkedin} from 'react-icons/bs'
// import {BsGithub} from 'react-icons/bs'
/*import {BsMedium} from 'react-icons/bs' */

const HeaderSocials = () => {
  return (
    
    <div className="header__socials">

        {/* <a href="https://www.linkedin.com/in/mitchelle-muiruri-477559269/" target="_blank" rel='noreferrer' style={{ marginRight: '20px'}} ><BsLinkedin/></a> */}
        {/* <a href="https://github.com/shaymuiruri" target="_blank" rel='noreferrer'><BsGithub/></a> */}
    </div>
  )
}

export default HeaderSocials